const lightBgThemeColors = [
  "#D65A31",
  "#0D7377",
  "#5432D3",
  "#00A8CC",
  "darkgray",
  "#F037A5",
  "#916BBF",
  "#1EAE98",
];
const darkBgThemeColors = [
  "lightblue",
  "#E6DDC4",
  "lightpink",
  "aquamarine",
  "lightgray",
  "lightgreen",
  "cyan",
  "#D9D7F1",
];
const extraColors = ["purple"];
const certBgLight = "#AAE3E2";
const certBgDark = "#3C84AB";
const highlightColor = "purple";

const ThemeData = {
  lightBgThemeColors,
  darkBgThemeColors,
  extraColors,
  certBgLight,
  certBgDark,
  highlightColor,
};
export default ThemeData;
